var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrowBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35863 0.558058C6.60271 0.802136 6.60271 1.19786 6.35863 1.44194L1.80057 6L6.35863 10.5581C6.60271 10.8021 6.60271 11.1979 6.35863 11.4419C6.11455 11.686 5.71882 11.686 5.47475 11.4419L0.474745 6.44194C0.230668 6.19786 0.230668 5.80214 0.474745 5.55806L5.47475 0.558058C5.71882 0.313981 6.11455 0.313981 6.35863 0.558058Z",
    fill: "#3E3E53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowBlack);
export default __webpack_public_path__ + "static/media/left_arrow_black.69edd54fbe10c1737bf608b67505827d.svg";
export { ForwardRef as ReactComponent };